import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["purebredTab", "mixedTab", "purebredPanel", "mixedPanel", "detailSection", "selectionDetails", "selectionSummary"]
  static values = { selectedId: String }

  connect() {
    // 初期状態でタブのスタイルを設定
    this.updateTabStyles()
  }

  // 純血種タブを表示
  showPurebreds(event) {
    event.preventDefault()
    this.purebredPanelTarget.classList.remove("hidden")
    this.mixedPanelTarget.classList.add("hidden")
    this.updateTabStyles("purebred")
  }

  // ミックス犬タブを表示
  showMixed(event) {
    event.preventDefault()
    this.purebredPanelTarget.classList.add("hidden")
    this.mixedPanelTarget.classList.remove("hidden")
    this.updateTabStyles("mixed")
  }

  // タブのスタイルを更新
  updateTabStyles(activeTab = "purebred") {
    const activeClasses = ["border-blue-500", "text-blue-600"]
    const inactiveClasses = ["border-transparent", "text-gray-500", "hover:text-gray-700"]

    if (activeTab === "purebred") {
      this.purebredTabTarget.classList.add(...activeClasses)
      this.purebredTabTarget.classList.remove(...inactiveClasses)
      this.mixedTabTarget.classList.remove(...activeClasses)
      this.mixedTabTarget.classList.add(...inactiveClasses)
    } else {
      this.mixedTabTarget.classList.add(...activeClasses)
      this.mixedTabTarget.classList.remove(...inactiveClasses)
      this.purebredTabTarget.classList.remove(...activeClasses)
      this.purebredTabTarget.classList.add(...inactiveClasses)
    }
  }

  // 犬種を選択
  selectBreed(event) {
    const selectedId = event.target.value

    if (!selectedId) return

    // 選択状態の値を更新
    this.selectedIdValue = selectedId

    // URLを更新して詳細セクションを取得
    const url = new URL(window.location.href)
    url.searchParams.set("selected_id", selectedId)

    // Turbo Driveを使用してページを部分的に更新
    Turbo.visit(url, { action: "replace" })
  }

  // 選択されたIDが変更されたとき
  selectedIdValueChanged() {
    // 自動スクロールは削除（ユーザーの操作を妨げるため）
    // 「一覧に戻る」ボタンによる明示的なスクロールは backToList() で実行
  }

  // 犬種一覧に戻る
  backToList(event) {
    event.preventDefault()

    if (this.hasSelectionDetailsTarget) {
      // Selection Section を展開
      this.selectionDetailsTarget.open = true

      // Selection Section までスクロール
      this.selectionDetailsTarget.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}
